// Taxonomia de tags del portafolio.
// Los proyectos guardan el tag canonico (tal como lo definio el estudio) y
// aca se traduce al idioma activo del visitante.
// Orden tomado del pedido del estudio: imagen, comercial, clips, identidad,
// tecnica mixta, cortometraje.

export const TAG_ORDER = [
  "ИМИДЖЕВЫЕ ПРОЕКТЫ",
  "КОММЕРЦИЯ",
  "КЛИПЫ",
  "АЙДЕНТИКА",
  "СМЕШАННАЯ ТЕХНИКА",
  "КОРОТКИЙ МЕТР",
];

const LABELS = {
  "ИМИДЖЕВЫЕ ПРОЕКТЫ": { en: "Image projects", ru: "Имиджевые проекты", es: "Proyectos de imagen" },
  "КОММЕРЦИЯ": { en: "Commercial", ru: "Коммерция", es: "Comercial" },
  "КЛИПЫ": { en: "Music videos", ru: "Клипы", es: "Videoclips" },
  "АЙДЕНТИКА": { en: "Identity", ru: "Айдентика", es: "Identidad" },
  "СМЕШАННАЯ ТЕХНИКА": { en: "Mixed technique", ru: "Смешанная техника", es: "Técnica mixta" },
  "КОРОТКИЙ МЕТР": { en: "Short film", ru: "Короткий метр", es: "Cortometraje" },
};

// Valores equivalentes en otros idiomas: si un proyecto quedo con el tag en
// ingles o espanol, se sigue mostrando con la traduccion correcta.
const ALIAS = {
  "IMAGE PROJECTS": "ИМИДЖЕВЫЕ ПРОЕКТЫ",
  "PROYECTOS DE IMAGEN": "ИМИДЖЕВЫЕ ПРОЕКТЫ",
  "COMMERCIAL": "КОММЕРЦИЯ",
  "COMERCIAL": "КОММЕРЦИЯ",
  "MUSIC VIDEOS": "КЛИПЫ",
  "VIDEOCLIPS": "КЛИПЫ",
  "IDENTITY": "АЙДЕНТИКА",
  "IDENTIDAD": "АЙДЕНТИКА",
  "MIXED TECHNIQUE": "СМЕШАННАЯ ТЕХНИКА",
  "TÉCNICA MIXTA": "СМЕШАННАЯ ТЕХНИКА",
  "SHORT FILM": "КОРОТКИЙ МЕТР",
  "CORTOMETRAJE": "КОРОТКИЙ МЕТР",
};

export function canonicalTag(tag) {
  const value = String(tag == null ? "" : tag).trim();
  if (!value) return "";
  if (LABELS[value]) return value;
  return ALIAS[value.toUpperCase()] || value;
}

export function tagLabel(tag, lang = "en") {
  const canon = canonicalTag(tag);
  const entry = LABELS[canon];
  if (!entry) return String(tag == null ? "" : tag);
  return entry[lang] || entry.en || entry.ru || entry.es || canon;
}

// Devuelve los tags sin repetir y en el orden definido por el estudio;
// cualquier tag fuera de la lista se agrega al final tal cual.
export function orderTags(tags = []) {
  const canon = Array.from(new Set(tags.map(canonicalTag).filter(Boolean)));
  const conocidos = TAG_ORDER.filter((t) => canon.includes(t));
  const otros = canon.filter((t) => !TAG_ORDER.includes(t));
  return [...conocidos, ...otros];
}
